import { render, staticRenderFns } from "./getPoints.vue?vue&type=template&id=b39740ee&scoped=true&"
import script from "./getPoints.vue?vue&type=script&lang=js&"
export * from "./getPoints.vue?vue&type=script&lang=js&"
import style0 from "./getPoints.vue?vue&type=style&index=0&id=b39740ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39740ee",
  null
  
)

export default component.exports